module.exports = __webpack_public_path__ + "img/cardup.a7dd6f62.png";